import PubSub from "pubsub-js";

import "core-js/fn/object/assign";
import "../lib/window-events";
import objectFitImages from "object-fit-images";
import "slick-carousel";

import { load } from "../sections";
import "../sections/announcement-bar";
import "../sections/modal";

function checkMobile() {
  return window.matchMedia("(max-width: 1140px)").matches;
}

function checkDesktop() {
  return window.matchMedia("(min-width: 1140px)").matches;
}

function toggles() {
  $("[data-toggle-target]").on("click", function (e) {
    e.preventDefault();

    let $target = $(this.dataset.toggleTarget);

    $target.stop().slideToggle(150);
  });
}

function mobileToggles() {
  let isMobile = checkMobile();

  $(document).on(
    "click",
    '#menu-primary-navigation .menu-item a[href="#"], .menu-item-subnav-toggle',
    function (e) {
      e.preventDefault();

      $(this).toggleClass("toggle-open");
      $(this).parent().parent().toggleClass("sub-nav__open");
      $(this).parent().next(".sub-menu__wrapper").stop().slideToggle(150);
    }
  );

  $(document).on("click", ".footer-toggle", function (e) {
    e.preventDefault();

    $(this).toggleClass("open");
    $(this).parent().children(".footer-toggle_body").stop().slideToggle(150);

    console.log($(this).parent().next(".footer-toggle_body"));
  });

  PubSub.subscribe("window:resize", function () {
    let current = checkMobile();

    if (isMobile != current) {
      isMobile = current;

      $(".sub-menu__wrapper").prop("style", false);
      $(".footer-toggle_body").prop("style", false);
    }
  });
}

function anchorLinks() {
  $(document).on("click", '[href^="#"]', function (e) {
    let $this = $(this);

    if ($this.attr("href") == "#") {
      e.preventDefault();

      return false;
    }

    let $target = $($this.attr("href"));

    if ($target.length > 0) {
      e.preventDefault();

      let scrollTop = Math.max($target.offset().top - 150, 0);

      $("html, body").animate({ scrollTop }, 250);

      return;
    }
  });
}

function carousels() {
  $(".has-slider-on-mobile .row").each(function () {
    let args = {
      mobileFirst: true,
      arrows: true,
      centerMode: true,
      slidesToShow: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick",
        },
      ],
    };

    $(this).slick(args);

    PubSub.subscribe("window:resize", (name, { width }) => {
      if (width <= 768) {
        return;
      }

      if (!$(this)[0].slick || $(this)[0].slick.unslicked) {
        $(this).slick(args);
      }
    });
  });

  $(".tiles .has-slider-on-mobile .row").each(function () {
    $(this).slick("unslick");
  });

  $(".slick-carousel").each(function () {
    let $this = $(this);
    let args = {
      infinite: false,
      adaptiveHeight: false,
      arrows: true,
      swipeToSlide: true,
      autoplay: false,
      autoplaySpeed: 7000,
      dots: true,
    };

    $this.slick(args);

    $this.on("swipe", (event) => {
      event.preventDefault();
    });
  });

  $(".testimonial-review-slider").each(function () {
    let $this = $(this);
    let args = {
      infinite: false,
      adaptiveHeight: true,
      arrows: false,
      swipeToSlide: true,
      autoplay: false,
      mobileFirst: true,
      dots: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick",
        },
      ],
    };

    $(this).slick(args);

    PubSub.subscribe("window:resize", (name, { width }) => {
      if (width <= 768) {
        return;
      }

      if (!$(this)[0].slick || $(this)[0].slick.unslicked) {
        $(this).slick(args);
      }
    });
  });
}

function clearFilters() {
  $("#clear-filters").on("click", function () {
    $(".filter input:checkbox").removeAttr("checked");

    var url = window.location.href;

    if (url.indexOf("?") != -1) url = url.split("?")[0];

    window.location.href = url;
  });
}

export default {
  init() {
    load("*");

    $(".nav-toggle").on("click", (e) => {
      e.preventDefault();

      document.body.classList.toggle("nav-open");
    });

    anchorLinks();
    mobileToggles();
    objectFitImages();
    carousels();
    toggles();
    clearFilters();

    window.iFrameResize();
  },
};

$(window).on("resize", function () {
  if (checkDesktop() == true) {
    document.body.classList.remove("nav-open");
  }
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js